import { ShoppingBagOutlined } from "@mui/icons-material";
import { Badge, IconButton, Tooltip } from "@mui/material";
import * as React from "react";
import { useSetRecoilState } from "recoil";
import { USE_ACTION_DRAWER } from "../../../hooks/useActionDrawer";
import { useCartValue } from "../../../hooks/useCart";

const ViewShoppingCartBtn: React.FC = () => {
  const cart = useCartValue();
  const setDrawer = useSetRecoilState(USE_ACTION_DRAWER);

  return (
    <Tooltip title="Voir Mon Panier">
      <IconButton color="inherit" onClick={() => setDrawer("CART")}>
        <Badge
          variant="standard"
          badgeContent={cart.carts.length}
          color="secondary"
        >
          <ShoppingBagOutlined />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default ViewShoppingCartBtn;
